import { MediaDatabaseApiUserAccount } from '../../../Admin/AccountManagement/models/media.database.api.user.account.model';
import { UserApiModel } from '../../../api/users/models/user.api.model';
import { validateEmail } from '../../../Common/Misc/helpers/formatting/email.helper';
import { userPermissionsEnum } from '../enums/user-permissions.enum';

export class UserModel {
    id: number;
    username?: string;
    email: string;
    firstName?: string;
    lastName?: string;
    title?: string;
    primaryPhone?: string;
    secondaryPhone?: string;
    accountsIds?: number[];
    isActive?: boolean;
    primaryAccountId?: number;
    permissions: userPermissionsEnum[];
    maxSessions?: number;
    neptuneOnly?: boolean;
    internal?: boolean;
    userClientId?: string;

    // F/E use only
    mediaDatabaseUserAccounts: MediaDatabaseApiUserAccount[] = [];

    constructor(apiEntity?: UserApiModel) {
        if (apiEntity) {
            this.constructFromApiEntity(apiEntity);
        } else {
            this.constructDefault();
        }
    }

    /**
     * Gets the full name of the provided user or the parts that are available
     */
    public getDisplayName(): string {
        let createdByName: string = null;

        if (this.firstName && this.lastName) {
            createdByName = `${this.firstName} ${this.lastName}`;
        } else if (this.firstName) {
            createdByName = this.firstName;
        } else if (this.lastName) {
            createdByName = this.lastName;
        }

        return createdByName;
    }

    /**
     * checks to see if the user has enough information to be submitted.
     */
    isFormValid() {
        return validateEmail(this.username?.trim()) &&
            validateEmail(this.email?.trim()) &&
            this.firstName?.trim() &&
            this.lastName?.trim() &&
            this.accountsIds?.length;
    }

    /**
     * Constructs this model based on the provided api entity
     */
    private constructFromApiEntity(apiEntity: UserApiModel): void {
        this.id = apiEntity.id;
        this.username = apiEntity.username;
        this.email = apiEntity.email;
        this.firstName = apiEntity.firstName;
        this.lastName = apiEntity.lastName;
        this.title = apiEntity.title;
        this.primaryPhone = apiEntity.primaryPhone;
        this.secondaryPhone = apiEntity.secondaryPhone;
        this.accountsIds = apiEntity.accountIds ? [...apiEntity.accountIds] : [];
        this.isActive = apiEntity.isActive;
        this.primaryAccountId = apiEntity.primaryAccountId;
        this.permissions = apiEntity.permissionIds ? [...apiEntity.permissionIds] : [];
        this.maxSessions = apiEntity.maxSessions;
        this.neptuneOnly = apiEntity.neptuneOnly;
        this.internal = apiEntity.internal;
        this.userClientId = apiEntity.userClientId;
    }

    /**
     * Constructs the default version of this model
     */
    private constructDefault(): void {
        this.id = null;
        this.username = null;
        this.email = null;
        this.firstName = null;
        this.lastName = null;
        this.title = null;
        this.primaryPhone = null;
        this.secondaryPhone = null;
        this.accountsIds = [];
        this.isActive = true;
        this.permissions = [];
        this.maxSessions = 1;
        this.neptuneOnly = true;
        this.internal = false;
    }

    toApiModel(): UserApiModel {
        return {
            id: this.id,
            username: this.username ? this.username.trim() : null,
            email: this.email ? this.email.trim() : null,
            firstName: this.firstName ? this.firstName.trim() : null,
            lastName: this.lastName ? this.lastName.trim() : null,
            title: this.title,
            primaryPhone: this.primaryPhone,
            secondaryPhone: this.secondaryPhone,
            accountIds: this.accountsIds?.slice(),
            isActive: this.isActive,
            primaryAccountId: this.primaryAccountId,
            permissionIds: this.permissions,
            maxSessions: this.maxSessions,
            neptuneOnly: this.neptuneOnly,
            internal: this.internal,
            userClientId: this.userClientId
        };
    }
}
